import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.scss';

const NAV_ITEMS = [
  { hash: '#services', label: 'Services' },
  { hash: '#about',    label: 'About' },
  { hash: '#gallery',  label: 'Gallery' },
  { hash: '#location', label: 'Location' },
  { hash: '#contact',  label: 'Book Now', highlight: true },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => { setShowMenu(false); }, [location]);

  const handleHashClick = (hash) => {
    setShowMenu(false);
    if (location.pathname !== '/') return;
    const el = document.getElementById(hash.replace('#', ''));
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}${showMenu ? ' navbar--open' : ''}`}>
      <div className="navbar__inner">

        {/* Brand */}
        <Link className="navbar__brand" to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <svg viewBox="0 0 260 72" xmlns="http://www.w3.org/2000/svg" aria-label="Priyaa's Beauty Salon">
            <defs>
              <linearGradient id="brandGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#d678d0" />
                <stop offset="100%" stopColor="#c9748a" />
              </linearGradient>
            </defs>
            {/* Scissor icon */}
            <text x="0" y="44" fontFamily="'Playfair Display', serif" fontSize="36" fontStyle="italic" fill="url(#brandGrad)">Priyaa's</text>
            <text x="3" y="62" fontFamily="'Montserrat', sans-serif" fontSize="10" fontWeight="400" letterSpacing="4" fill="#9c6b7a" textTransform="uppercase">BEAUTY SALON</text>
            <line x1="2" y1="52" x2="100" y2="52" stroke="url(#brandGrad)" strokeWidth="0.8" opacity="0.5" />
          </svg>
        </Link>

        {/* Hamburger */}
        <button
          className={`navbar__toggler${showMenu ? ' navbar__toggler--active' : ''}`}
          onClick={() => setShowMenu(v => !v)}
          aria-label="Toggle navigation"
          aria-expanded={showMenu}
        >
          <span /><span /><span />
        </button>

        {/* Links */}
        <ul className={`navbar__links${showMenu ? ' navbar__links--open' : ''}`}>
          <li>
            <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Home</Link>
          </li>
          {NAV_ITEMS.map(item => (
            <li key={item.hash}>
              <Link
                to={`/${item.hash}`}
                className={item.highlight ? 'navbar__book' : ''}
                onClick={() => handleHashClick(item.hash)}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
